module.exports = __webpack_public_path__ + "static/img/LINE.daafc03a.svg";